import {NgModule} from '@angular/core';
import {ReporteEstadoComponent} from './components/reporte.estado.component';
import {ReporteServices} from './services/reporte.services';
import {ReportesRoutingModule} from './reportes.routing.module';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {NgxChartsModule} from '@swimlane/ngx-charts';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {CategoriasWidgetComponent} from './components/widgets/categorias.widget.component';
import {EstadoWidgetComponent} from './components/widgets/estado.widget.component';
import {IndGeneralWidgetComponent} from './components/widgets/ind.general.widget.component';
import {IndicadoresWidgetComponent} from './components/widgets/indicadores.widget.component';
import {ParticipacionWidgetComponent} from './components/widgets/participacion.widget.component';
import {VentasWidgetComponent} from './components/widgets/ventas.widget.component';
import {ReporteDashboardComponent} from './components/reporte.dashboard.component';
import {CoreModule} from '../CoreModule/core.module';
import {ChartsModule} from 'ng2-charts';
import {ReporteHoySemanaComponent} from './components/reporte.hoy.semana.component';
import {ReporteComparativoDashboardComponent} from './components/reporte.comparativo.dashboard.component';
import {VentasComparativoWidgetComponent} from './components/widgets/ventas.comparativo.widget.component';
import {IndicadoresComparativoWidgetComponent} from './components/widgets/indicadores.comparativo.widget.component';
import {AlertModule, TypeaheadModule} from 'ngx-bootstrap';
import {ReporteRegionalDashboardComponent} from './components/reporte.regional.dashboard.component';
import {ReporteMarcasComponent} from './components/reporte.marcas.component';
import {
  CategoriaMarcaWidgetComponent,
  MarcaCategoriaColaboradorComponent,
  MarcaVentasWidgetComponent
} from './components/widgets/categoria.marca.widget.component';
import {ReporteMarcasColaboradorComponent} from './components/reporte.marcas.colaborador.component';
import {ReporteMarcasRegionalComponent} from './components/reporte.marcas.regional.component';
import {ReporteMarcasGeneralRegionalComponent} from './components/reporte.marcas.general.regional.component';
import {ReporteInventarioCategoriaComponent} from './components/reporte.inventario.categoria.component';
import {InventarioServices} from './services/inventario.services';
import {ReporteProddescPrecioventaComponent} from './components/reporte.proddesc.precioventa.component';
import {ReporteInventarioPrecioventComponent} from './components/reporte.inventario.preciovent.component';
import {EditMarcasComponent, MarcasCrudComponent, NewMarcasComponent} from './components/marcas/marcas.crud.component';
import {MarcasServices} from './services/marcas.services';
import {ReporteVencimientosComponent} from './components/reporte.vencimientos.component';

@NgModule({
  declarations: [
    ReporteEstadoComponent,
    CategoriasWidgetComponent,
    EstadoWidgetComponent,
    IndGeneralWidgetComponent,
    IndicadoresWidgetComponent,
    ParticipacionWidgetComponent,
    VentasWidgetComponent,
    ReporteDashboardComponent,
    ReporteRegionalDashboardComponent,
    ReporteHoySemanaComponent,
    ReporteComparativoDashboardComponent,
    VentasComparativoWidgetComponent,
    IndicadoresComparativoWidgetComponent,
    ReporteMarcasComponent,
    ReporteMarcasColaboradorComponent,
    CategoriaMarcaWidgetComponent,
    MarcaVentasWidgetComponent,
    MarcaCategoriaColaboradorComponent,
    ReporteMarcasRegionalComponent,
    ReporteMarcasGeneralRegionalComponent,
    ReporteInventarioCategoriaComponent,
    ReporteProddescPrecioventaComponent,
    ReporteInventarioPrecioventComponent,
    MarcasCrudComponent,
    EditMarcasComponent,
    NewMarcasComponent,
    ReporteVencimientosComponent

  ],
  imports: [
    CommonModule,
    FormsModule,
    BrowserModule,
    NgxChartsModule,
    ReportesRoutingModule, BrowserAnimationsModule, CoreModule, ChartsModule,
    TypeaheadModule.forRoot(),
    AlertModule.forRoot()

  ],
  providers: [ReporteServices, InventarioServices, MarcasServices]
})
export class ReportesModule {

}
